module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "embedded-website-container"
  }, [_c('iframe', {
    staticClass: "embedded-website",
    attrs: {
      "src": _vm.websiteUrl
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-249a4589","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/WheelsTrack.vue
// module id = 2467
// module chunks = 0